module.exports = require("@material-ui/core/Paper");